(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eu-garan-label"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lnx-casafan-garan')) {
  customElements.define('lnx-casafan-garan', class extends HTMLElement {
    connectedCallback() {
      this.labels = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.controller = new AbortController();
      this.updateLabel(this.dataset.variantId);
      document.addEventListener('variant:change', event => {
        const id = event.detail?.variant?.id;
        if (id != null && Object.prototype.hasOwnProperty.call(this.labels, String(id))) {
          this.dataset.variantId = String(id);
          this.updateLabel(String(id));
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    updateLabel(id) {
      const url = this.labels[id];
      this.hidden = !url;
      const img = this.querySelector('.lnx-garan__image');
      if (url && img) {
        img.removeAttribute('srcset');
        img.setAttribute('src', url);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lightnox-depth-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    if (!event.target.matches('.lightnox-depth-filter select')) return;
    const select = event.target;
    const container = select.closest('.lightnox-depth-filter').querySelector('[data-depth-values]');
    container.replaceChildren();
    if (!select.value) return;
    const limit = Number(select.value);
    for (const option of select.options) {
      if (!option.value || Number(option.value) > limit) continue;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = select.dataset.filterName;
      input.value = option.value;
      container.append(input);
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
